<div tabindex="-1"
    class="fixed left-0 top-0 z-50 w-full p-4 md:inset-0 h-full flex bg-black/50 backdrop-blur-sm overflow-auto">
    <div [class]="'rounded-2xl max-h-full w-full m-auto '+ (maxWidth? 'max-w-'+maxWidth:'max-w-2xl')">
        <!-- Modal content -->
        <div class="rounded-2xl bg-white/95 backdrop-blur-lg shadow-2xl border border-white/50">
            <div
                class="flex items-center justify-between rounded-t-2xl border-b border-blue-200/70 px-3 py-2 bg-linear-to-r from-blue-50/50 to-purple-50/50 relative">
                <div>
                    <h3 class="text-lg font-semibold lg:text-xl text-neutral-800">
                        {{customTitle}}
                    </h3>
                </div>

                <button type="button"
                    class="cursor-pointer inline-flex h-8 w-8 items-center justify-center rounded-lg bg-neutral-100 hover:bg-neutral-200 text-neutral-500 hover:text-neutral-700 transition-all duration-200 border border-neutral-200"
                    (click)="closeModal()">
                    X
                </button>
            </div>

            <!-- Modal body -->
            <div class="relative z-10 p-3 bg-white/70 backdrop-blur-sm" [class.rounded-b-2xl]="hideFooter">
                <ng-content></ng-content>
            </div>

            @if(!hideFooter) {
            <div
                class="flex justify-end space-x-3 rounded-b-2xl border-t border-blue-200/70 px-3 py-2 bg-gray-50/80 backdrop-blur-sm">
                <button type="button" tabindex="-1"
                    class="cursor-pointer px-6 py-2.5 text-sm font-medium text-neutral-600 bg-white border border-blue-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    (click)="closeModal()">
                    Cancelar
                </button>

                <button type="button"
                    class="cursor-pointer px-6 py-2.5 text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300 rounded-lg transition-all duration-200"
                    (click)="acceptModal()">
                    Aceptar
                </button>
            </div>
            }
        </div>
    </div>
</div>